/* Patriot Bikes V2.0 — "Our Bikes" tabbed grid.
   Accessible tabs: click + arrow-key roving focus. Panels toggle via [hidden]. */
class PBBikeGrid extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
    });

    // Swipe affordance: fade the edge(s) with more tabs, self-correcting on scroll.
    this.tablist = this.querySelector('.pb-bikes__tabs');
    if (this.tablist) {
      this.updateFade = () => {
        const el = this.tablist;
        const scrollable = el.scrollWidth > el.clientWidth + 1;
        el.classList.toggle('is-scrollable', scrollable);
        el.classList.toggle('at-start', el.scrollLeft <= 1);
        el.classList.toggle('at-end', el.scrollLeft + el.clientWidth >= el.scrollWidth - 1);
      };
      this.tablist.addEventListener('scroll', this.updateFade, { passive: true });
      window.addEventListener('resize', this.updateFade, { passive: true });
      this.updateFade();
      requestAnimationFrame(this.updateFade); // re-check once fonts/layout settle
    }
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (this.panels[i]) this.panels[i].hidden = !selected;
    });
    this.scrollTabIntoView(this.tabs[index]);
  }

  scrollTabIntoView(tab) {
    const el = this.tablist;
    if (!el || !tab) return;
    const t = tab.getBoundingClientRect();
    const c = el.getBoundingClientRect();
    if (t.left < c.left) el.scrollBy({ left: t.left - c.left - 16, behavior: 'smooth' });
    else if (t.right > c.right) el.scrollBy({ left: t.right - c.right + 16, behavior: 'smooth' });
  }

  onKeydown(e, i) {
    const last = this.tabs.length - 1;
    let next = null;
    if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
    else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = last;
    if (next === null) return;
    e.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }
}

if (!customElements.get('pb-bike-grid')) {
  customElements.define('pb-bike-grid', PBBikeGrid);
}
